import React from 'react';
import BibleVerse from '../utils/BibleVerse';

function WhatWeBelieve(props) {
  return (
    <div>
      <h2>Our Beliefs</h2>
      <div id="contentRight">
        <h3>The Bible</h3>
        <ol type="1">
          <li>Both the Old and New Testament Scriptures are verbally inspired by God, inerrant in the original manuscripts, and are the ultimate authorities in all areas of faith and practice.</li>
          <li>The Scriptures should be interpreted literally whenever possible, consistently, contextually, grammatically, culturally, and historically.
            <p><em>
              <BibleVerse reference="PSA.19.7-11" text="Psalm 19:7-11" />
              <BibleVerse reference="PSA.119.160" text="Psalm 119:160" />
              <BibleVerse reference="2PE.1.19-21" text="2 Peter 1:19-21" />
              <BibleVerse reference="2TI.3.16-17" text="2 Timothy 3:16-17" />
              <BibleVerse reference="REV.22.18-19" text="Revelation 22:18-19" />
            </em></p>
          </li>
        </ol>
        <h3>God</h3>
        <ol type="1">
          <li>The Godhead, also known as &quot;The Trinity,&quot; eternally exists in three persons: GOD THE FATHER, GOD THE SON, and GOD THE HOLY SPIRIT. They are one God, having the same nature, attributes, and perfection.
            <p><em>
              <BibleVerse reference="ISA.48.16" text="Isaiah 48:16" />
              <BibleVerse reference="MAT.28.19" text="Matthew 28:19" />
              <BibleVerse reference="JHN.17.5" text="John 17.5" />
              <BibleVerse reference="ROM.1.20" text="Romans 1:20" />
              <BibleVerse reference="2CO.13.14" text="2 Corinthians 13:14" />
            </em></p>
          </li>
          <li>The Father is perfect in holiness, almighty in power, and infinite in wisdom. As the Creator of all, He is the Father to all men, but He is a spiritual Father only to those who believe in the Lord Jesus Christ.
            <p><em>
              <BibleVerse reference="PSA.145.8-9" text="Psalm 145:8-9" />
              <BibleVerse reference="MAT.5.45" text="Matthew 5:45" />
              <BibleVerse reference="MAT.6.24-34" text="Matthew 6:24-34" />
              <BibleVerse reference="JHN.14.6" text="John 14:6" />
              <BibleVerse reference="1TI.2.5" text="1 Timothy 2:5" />
            </em></p>
          </li>
          <li>We believe in the personality and deity of the Lord Jesus Christ, begotten of the Holy Spirit, born of the virgin Mary, truly God and truly Man. We believe in His sinless life, His vicarious atonement for the sins of mankind by the shedding of His blood on the cross, and in His bodily resurrection from the tomb.
            <p><em>
              <BibleVerse reference="MAT.1.20" text="Matthew 1:20" />
              <BibleVerse reference="LUK.1.30-37" text="Luke 1:30-37" />
              <BibleVerse reference="JHN.1.1" text="John 1:1" />
              <BibleVerse reference="JHN.1.14" text="John 1:14" />
              <BibleVerse reference="JHN.10.30" text="John 10:30" />
              <BibleVerse reference="PHP.2.5-7" text="Philippians 2:5-7" />
              <BibleVerse reference="COL.1.19" text="Colossians 1:19" />
              <BibleVerse reference="1TI.3.16" text="1 Timothy 3:16" />
            </em></p>
          </li>
          <li>The Holy Spirit is the divine third person of the Godhead, and thereby co-equal with the Father and the Son. He is the infallible interpreter of the Word of God. He convicts man of sin; indwells every believer; is ever present to testify of Christ; regenerates; baptizes; seals the believer; guides; teaches; empowers the life of the believer; and is vitally involved in the sanctification of the believer.
            <p><em>
              <BibleVerse reference="JHN.3.5-8" text="John 3:5-8" />
              <BibleVerse reference="JHN.14.16-18" text="John 14:16-18" />
              <BibleVerse reference="JHN.16.8-11" text="John 16:8-11" />
              <BibleVerse reference="ROM.8.9" text="Romans 8:9" />
              <BibleVerse reference="1CO.12.13" text="1 Corinthians 12:13" />
              <BibleVerse reference="2CO.3.18" text="2 Corinthians 3:18" />
              <BibleVerse reference="EPH.1.13" text="Ephesians 1:13" />
              <BibleVerse reference="EPH.5.18" text="Ephesians 5:18" />
            </em></p>
          </li>
        </ol>
        <h3>Creation</h3>
        <p>We believe that the account of the six-day creation as given in the Book of Genesis is to be understood literally and that creation was a direct act of God.</p>
        <p>Therefore, we teach that any evolutionary hypothesis is totally inconsistent with the Scriptures.</p>
        <p><em>
          <BibleVerse reference="GEN.1" text="Genesis 1:1-2:25" />
          <BibleVerse reference="GEN.5.1-2" text="Genesis 5:1-2" />
          <BibleVerse reference="EXO.20.11" text="Exodus 20:11" />
          <BibleVerse reference="EXO.31.17" text="Exodus 31:17" />
          <BibleVerse reference="PSA.33.6-9" text="Psalm 33:6-9" />
          <BibleVerse reference="JHN.1.3-10" text="John 1:3-10" />
          <BibleVerse reference="ACT.17.24-28" text="Acts 17:24-28" />
          <BibleVerse reference="ROM.1.19-20" text="Romans 1:19-20" />
          <BibleVerse reference="ROM.5.12" text="Romans 5:12" />
          <BibleVerse reference="COL.1.16" text="Colossians 1:16" />
          <BibleVerse reference="HEB.3.3-4" text="Hebrews 3:3-4" />
          <BibleVerse reference="HEB.11.3" text="Hebrews 11:3" />
        </em></p>
        <h3>Mankind</h3>
        <ol type="1">
          <li>Man was directly and immediately created by God in His likeness, free of sin, with a rational nature, intelligence, volition, self-determination, and moral responsibility to God; and,</li>
          <li>God&#39;s intention in the creation of man was that man should glorify God, enjoy His fellowship, live his life in the will of God, and by this accomplish God&#39;s purpose for him.</li>
        </ol>
        <p><em>
          <BibleVerse reference="GEN.2.7" text="Genesis 2:7" />
          <BibleVerse reference="GEN.2.15-25" text="Genesis 2:15-25" />
          <BibleVerse reference="GEN.3.21" text="Genesis 3:21" />
          <BibleVerse reference="GEN.6.6" text="Genesis 6:6" />
          <BibleVerse reference="GEN.9.6" text="Genesis 9:6" />
          <BibleVerse reference="PSA.139.13-16" text="Psalm 139:13-16" />
          <BibleVerse reference="ISA.43.7" text="Isaiah 43:7" />
          <BibleVerse reference="ACT.17.24-26" text="Acts 17:24-26" />
          <BibleVerse reference="COL.1.16" text="Colossians 1:16" />
          <BibleVerse reference="JAS.3.9" text="James 3:9" />
          <BibleVerse reference="REV.4.11" text="Revelation 4:11" />
        </em></p>
        <h3>Sin&nbsp;</h3>
        <p>We believe that, in Adam's sin of disobedience to the revealed will and Word of
        God, man lost his innocence; incurred the penalty of spiritual and physical death;
        became subject to the wrath of God; and became inherently corrupt and apart
        from divine grace, utterly incapable of choosing or doing that which is acceptable
        to God. With no recuperative powers to enable him to recover himself, man is
        hopelessly lost. Therefore, man's salvation is wholly dependent upon the
redemptive work of our Lord Jesus Christ.</p>
        <p><em>
          <BibleVerse reference="GEN.2.17" text="Genesis 2:17" />
          <BibleVerse reference="GEN.3.1-19" text="Genesis 3:1-19" />
          <BibleVerse reference="JHN.3.17-18" text="John 3:17-18" />
          <BibleVerse reference="JHN.3.36" text="John 3:36" />
          <BibleVerse reference="ROM.3.10-12" text="Romans 3:10-12" />
          <BibleVerse reference="ROM.3.23" text="Romans 3:23" />
          <BibleVerse reference="ROM.6.23" text="Romans 6:23" />
          <BibleVerse reference="1CO.2.14" text="1 Corinthians 2:14" />
          <BibleVerse reference="EPH.2.1-3" text="Ephesians 2:1-3" />
          <BibleVerse reference="1TI.2.13-14" text="1 Timothy 2:13-14" />
          <BibleVerse reference="1JN.1.8" text="1 John 1:8" />
        </em></p>
      </div>
    </div>
  )
}

export default WhatWeBelieve;
